import { BaseWithId } from '@app/shared/models/base';
import { ActionListItem } from '@app/shared/components/action-list/action-list.component';
import { Address } from '@app/shared/models/address';
import { UserAssignment } from '@app/shared/models/user-assignment';
import { Bank } from '@app/shared/models/bank';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class Office extends BaseWithId implements ActionListItem {

    public name1: string;
    public name2: string;
    public name3: string;

    public officeCode: string;
    public tax_number: string;
    public tax_number2: string;

    public commercial_register_number: string;
    public ceo: string[];

    public address: Address;
    public bankDetails: Bank[];

    public member_structure: UserAssignment;

    public trans = {
        name1: marker('office.name1'),
        name2: marker('office.name2'),
        name3: marker('office.name3'),
        officeCode: marker('office.officeCode'),
        tax_number: marker('office.tax_number'),
        tax_number2: marker('office.tax_number2'),
        commercial_register_number: marker('office.commercial_register_number'),
        ceo: marker('office.ceo')
    };

    get names(): string {
        return `${this.name1 ? this.name1 : ``}
                ${this.name2 ? (this.name1 ? `, ${this.name2}` : this.name2) : ``}
                ${this.name3 ? (this.name1 || this.name2 ? `, ${this.name3}` : this.name3) : ``}`;
    }

    get codeAndNames(): string {
        return `${this.officeCode ? this.officeCode : ``}${this.names ? (this.officeCode ? `, ${this.names}` : this.names) : ``}`;
    }

    get actionListDisplayName(): string {
        return this.officeCode || '';
    }

    constructor(json?: any) {
        super(json);
    }


    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            ceo: json && json.ceo ? json.ceo.map(c => c) : [],
            address: new Address(json && json.address),
            bankDetails: json && json.bankDetails ? json.bankDetails.map(bank => new Bank(bank)) : [],
            member_structure: json && json.member_structure ? new UserAssignment(json.member_structure) : null
        });
    }
}
